module.exports = __webpack_public_path__ + "01e5492028087961c9d8e65ed6bb6f1f.svg";